


// export interface IValueConvertionService extends IValueConverter {
// }

import { CancellationToken } from "../../../base/common/cancellation";

export const ValueConversionService = new class implements IValueConverter {

    private readonly converters: IValueConverter[] = [];

    registerConverter(convert: IValueConverter): void {
        if (this.converters.includes(convert)) {
            return;
        }
        this.converters.push(convert);
    }

    canConvert(value: unknown, usage: ValueConverterOptions): boolean {
        for (const converter of this.converters) {
            try {
                if (converter.canConvert(value, usage)) {
                    return true;
                }
            }
            catch (e) {
                console.error("Error during value conversion check with converter:", converter, e);
            }
        }
        return false;
    }

    async convert<T extends unknown>(value: unknown, usage: ValueConverterOptions): Promise<T | null> {
        for (const converter of this.converters) {
            try {
                if (converter.canConvert(value, usage)) {
                    return converter.convert<T>(value, usage);
                }
            }
            catch (e) {
                console.error("Error during value conversion with converter:", converter, e);
            }
        }

        // No converter found (only log if value is not null/undefined)
        if (value !== null && value !== undefined) {
            console.warn("ValueConversionService: No converter found", typeof value, usage);
        }


        return null;
    }
}




// #region Property Value Converter

export interface ValueConverterOptions {
    token?: CancellationToken,
    targetType: "texture" | "blob:url" // e.g., "image/png", "image/jpeg", etc.
    width?: number,
    height?: number,
    usageHint?: "skybox",
}

export interface IValueConverter {
    canConvert(value: unknown, target: ValueConverterOptions): boolean;
    convert<T extends unknown>(value: unknown, target: ValueConverterOptions): Promise<T | null>;
}
